import { styled } from "styled-system/jsx";

/**
 * An empty container that fills all available space
 */
export const Spacer = styled("div", {
  base: {
    flexGrow: 1,
  },
});
